import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import InvoiceSettings from './InvoiceSettings';
import PrefixSettings from './PrefixSettings';
import FinancePaymentSettings from './FinancePaymentSettings';
import CurrencySettings from './CurrencySettings';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FinanceSettings() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <Box sx={{ width: '100%', backgroundColor: 'white' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="finance settings tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#FFCC00',
              transition: 'all 0.3s ease',
            },
          }}
          sx={{
            '.MuiTab-root': {
              color: 'black',
              fontWeight: 'bold',
              transition: 'color 0.3s ease',
            },
            '.Mui-selected': {
              color: 'black',
            },
          }}
        >
          <Tab label="Invoice Settings" {...a11yProps(0)} />
          <Tab label="Prefix Settings" {...a11yProps(1)} />
          <Tab label="Invoice Payment Details" {...a11yProps(2)} />
          <Tab label="Currency Details" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <InvoiceSettings />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <PrefixSettings  />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <FinancePaymentSettings />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <CurrencySettings />
      </CustomTabPanel>
    </Box>
  );
}
